const ErrorMap: Record<string, string> = {
  SSO_0001:
    'O email escolhido não está cadastrado na nossa plataforma, certifique-se de que o email usado é o seu email corporativo.',
};

export function getMessage(errorCode: string | undefined) {
  return !errorCode ? undefined : ErrorMap[errorCode];
}
